import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DsSelectComponent } from './components/select/select.component';
import { DsSelectOptionComponent } from './components/select-option/select-option.component';
import { SkyMiscModule } from '@skyeng/libs/shared/misc';

@NgModule({
  imports: [CommonModule, SkyMiscModule],
  declarations: [DsSelectComponent, DsSelectOptionComponent],
  exports: [DsSelectComponent, DsSelectOptionComponent],
})
export class DsSelectModule {}
